import { useTheme } from '@/Hooks'
import React from 'react'
import Text from './Text'

export const SubTitle = props => {
  const { theme } = useTheme()
  return <Text regular color={theme.colors.grey2} {...props} />
}
